import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Input } from "antd";
import AccountLinks from "./AccountLinks";
import { languageLable } from "utilities/helpers";
import { FaPen } from "react-icons/fa";
import EmailPhoneSelectionModal from "./OTP/EmailPhoneSelectionModal";
import API from "api/api";

const api = new API();

class UserInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactMethod: "",
        openOTPModal: false,
      enableWhatsapp: false,
    };
    }

    componentDidMount = async () => {
        setTimeout(() => {
            console.log("Auth: ", this.props.auth.appDefaultSetting.SendWhatsappOTP);

            if (this.props && this.props.auth && this.props.auth.appDefaultSetting && this.props.auth.appDefaultSetting.SendWhatsappOTP) {
                this.setState({
                    enableWhatsapp: this.props.auth.appDefaultSetting.SendWhatsappOTP,
                });
            }
        }, 500);
        
    };

  handleCloseSelectionModal = () => {
    this.props.dispatch({
      type: "OPEN_EMAIL_PHONE_OPTION_MODAL",
      openEmailPhoneOptionModal: false,
    });
  };

  handleOpenSelectionModal = () => {
    this.props.dispatch({
      type: "OPEN_EMAIL_PHONE_OPTION_MODAL",
      openEmailPhoneOptionModal: true,
    });
    };

    handleToggleWhatsapp = async (enabled) => {
        this.setState({ enableWhatsapp: enabled });
        console.log("Call API");
        try {
            api.get("UpdateWhatsappOTPSend?sendWhatsappOTP=" + enabled).then((response) => {
                if (response.StatusCode === 200 && response.Result) {
                  //  window.location.reload();     
                }
            });
        } catch (error) {
            console.error("Error updating whatsapp:", error);
            // rollback state if API fails
            this.setState({ enableWhatsapp: enabled });
        }
    };

  render() {
    const initialValues = {};
    if (this.props && this.props.auth && this.props.auth.userData) {
      initialValues.name = this.props.auth.userData.name;
      initialValues.email = this.props.auth.userData.email;
      initialValues.mobile = this.props.auth.userData.mobile;
    }
    const { selectedLanguageData } = this.props.app;
    const { openEmailPhoneOptionModal } = this.props.auth;

    return (
      <section className="ps-my-account ps-page--account ps-user-account-wrapper">
        <div className="ps-container">
          <div className="row">
            <AccountLinks page="user-information" />
            <div className="col-lg-8">
              <div className="ps-form--account-setting ps-form--user-info">
                <div className="ps-form__header">
                  <h3>
                    {languageLable(selectedLanguageData, "Account Information")}
                  </h3>
                  <FaPen
                    className="edit-icon"
                    onClick={this.handleOpenSelectionModal}
                  />
                </div>
                <div className="ps-form__content">
                  <figcaption>
                    <div className="field-title">
                      {languageLable(selectedLanguageData, "Name")}:
                    </div>
                    <div className="field-value">{initialValues.name}</div>
                  </figcaption>
                  <figcaption>
                    <div className="field-title">
                      {languageLable(selectedLanguageData, "Email")}:
                    </div>
                    <div className="field-value">{initialValues.email}</div>
                  </figcaption>
                  <figcaption>
                    <div className="field-title">
                      {languageLable(selectedLanguageData, "Mobile")}:
                    </div>
                    <div className="field-value">{initialValues.mobile}</div>
                  </figcaption>
                                <figcaption>
                                    <div className="field-title">
                                        {languageLable(selectedLanguageData, "Enable Whatsapp OTP")}:
                                    </div>
                                    <div className="field-value field-value-togglerr">
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={this.state.enableWhatsapp === true}
                                                onChange={(e) => this.handleToggleWhatsapp(e.target.checked)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </figcaption>
                  <EmailPhoneSelectionModal
                    open={openEmailPhoneOptionModal}
                    onClose={this.handleCloseSelectionModal}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  editUserDetailForm = (initialValues) => {
    return (
      <Form
        className="ps-form--account-setting"
        onSubmit={this.handleLoginSubmit}
        initialValues={{ ...initialValues }}
      >
        <div className="ps-form__header">
          <h3>Account Information</h3>
        </div>
        <div className="ps-form__content">
          <div className="control-label">Full Name</div>
          <div className="form-group">
            <Form.Item
              name="name"
              rules={[
                {
                  required: false,
                  message: "Please input your name!",
                },
              ]}
            >
              <Input
                name="name"
                className="form-control"
                type="text"
                placeholder="Username or email address"
              />
            </Form.Item>
          </div>
          <div className="form-group">
            <div className="control-label">Mobile</div>
            <Form.Item
              name="mobile"
              rules={[
                {
                  required: false,
                  message: "Please enter your mobile number.",
                },
              ]}
            >
              <Input
                name="mobile"
                className="form-control"
                disabled={true}
                type="text"
                placeholder="Enter your phone number"
              />
            </Form.Item>
          </div>
          <div className="control-label">Email</div>
          <div className="form-group">
            <Form.Item
              name="email"
              rules={[
                {
                  required: false,
                  message: "Please enter your email.",
                },
              ]}
            >
              <Input
                name="email"
                className="form-control"
                disabled={true}
                type="text"
                placeholder="Username or email address"
              />
            </Form.Item>
          </div>
          <div className="form-group submit">
            <button className="ps-btn">Update</button>
          </div>
        </div>
      </Form>
    );
  };
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(withRouter(UserInformation));
